export default {
  'viewPaymentRuleModifications.header': 'View Rule Modifications',
  'viewPaymentRuleModifications.ruleOverview': 'Rule Overview',
  'viewPaymentRuleModifications.userModifications': 'User Modifications',
  'viewPaymentRuleModifications.actionTaken': 'Action Taken',
  'viewPaymentRuleModifications.dateAndTime': 'Date & Time',
  'viewPaymentRuleModifications.modifications': 'Modifications',
  'viewPaymentRuleModifications.modification': 'Modification',
  'viewPaymentRuleModifications.accountAdded': 'Account(s) Added',
  'viewPaymentRuleModifications.accountRemoved': 'Account(s) Removed',
  'viewPaymentRuleModifications.tranTypesAdded': 'Standard Entry Class Code (SEC) Added',
  'viewPaymentRuleModifications.tranTypesRemoved': 'Standard Entry Class Code (SEC) Removed',
  'viewPaymentRuleModifications.modifiedFiled': '<%= oldValue %> changed to <%= newValue %>',
  // Timing
  'viewPaymentRuleModifications.added': 'added',
  'viewPaymentRuleModifications.removed': 'removed',
  'viewPaymentRuleModifications.singleDay': 'single day',
  'viewPaymentRuleModifications.range': 'range',
  'viewPaymentRuleModifications.singleDayWindow': 'On <%= firstDay %> of every month',
  'viewPaymentRuleModifications.rangeWindow': 'From <%= firstDay %> to <%= lastDay %> every month'
};
